<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span class="lock" :title="$gettext('Sdílený profil. Nelze editovat.')" v-if="!$_updateActionAllowed" />
      <input
          type="checkbox"
          :id="entity.id"
          :value="entity.id"
          @click.stop
          @change="onChange"
          :checked="isChecked"
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <span class="lock" v-if="!$_updateActionAllowed" 	:title="'Sdílený profil. Nelze editovat.' | translate" v-translate>Zamčeno</span>
    <td :data-th="'Název profilu' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Kód' | translate">
      {{ entity.code }}
    </td>
    <td :data-th="'Rozlišení' | translate">
      {{ entity.resolution.width }}x{{ entity.resolution.height }}
    </td>
    <td :data-th="'Bitrate' | translate">
      {{ entity.bitrate }}
    </td>
    <td :data-th="'Kodek' | translate">
      {{ entity.codec_name }}
    </td>
    <td :data-th="'Synchronizační skupina' | translate">
      {{ entity.sync_group }}
    </td>
    <td :data-th="'Videotéka' | translate">
      <img
          class="is_set"
          src="../../../assets/images/is-set.svg"
          :alt="'Ano' | translate"
          v-if="entity.vod">
    </td>
    <td :data-th="'Operátor' | translate" v-if="$_readActionAllowedAllOrOwnAndGlobal">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteStreamProfile">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "StreamProfileRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'streamProfiles',
      detailPageRouteName: 'streamProfileDetail',
    }
  },
  methods: {
    emitDeleteStreamProfile() {
      this.$emit('deleteStreamProfile', String(this.entity.id))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/StreamProfileRow.vue